import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: "center",
    // fontFamily: "Oswald",
    margin: 4,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  author: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    // fontFamily: "Oswald",
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Times-Roman",
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    margin: 10,
    textAlign: "center",
    color: "grey",
    marginBottom: 20,
    marginTop: 20,
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: { margin: "auto", flexDirection: "row" },
  tableCol: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10,
    display: "flex",
    flexDirection: "row",
  },
  logo: {
    height: 30,
    width: 150,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  normalText: {
    fontSize: 12,
    margin: 4,
  },
  divider: {
    width: "80%",
    borderStyle: "solid",
    borderWidth: 1.5,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    margin: 10,
  },

  contact: {
    fontSize: 14,
    margin: 4,
    marginTop: 50,
    fontWeight: "bold",
  },
  container: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    margin: 10,
    padding: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  flexRow: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
});
